import React from "react";
import {Button, message, } from 'antd';
import NHFetch from "../../../utils/NHFetch";
import getSize from "../../../utils/getSize";
import css from './style.css';
import NHTable from '../../common/NHTable/index'
import NHContainerFrame from "../../common/NHContainerFrame/index";
import {NHConfirm} from '../../common/NHModal/index';
import {hasAuth} from '../../../utils/NHCore';
import EditForm from "./EditForm";

const basicUrl = "/xxcj/zdgl/";

/**
 * @author weishihuai
 * @date 2018/6/29
 * @time 16:05
 * @Description: 迎新系统-字段管理
 */
export default class ZdglTab extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            frameVisibleMap: {
                tableFlag: true,         //列表Tab显示标志
                addFlag: false,          //新增Tab显示标志
                updateFlag: false,       //修改Tab显示标志
                showOperationBtn: false, //按钮显示标志
            },
            updatePkid: '',              //修改的字段主键ID
            formInitData: {},            //表单初始化数据
        };
    }

    //设置当前显示页面
    setCurrentPageShow = (showFlagName) => {
        let frameVisibleMap = this.state.frameVisibleMap;
        for (let name in frameVisibleMap) {
            frameVisibleMap[name] = name === showFlagName;
        }
        this.setState({
            frameVisibleMap: frameVisibleMap
        });
    };

    //新增字段事件
    addBtnClickListener = () => {
        this.setCurrentPageShow('addFlag');
    };

    //导出EXCEL事件
    exportBtnClickListener = () => {
        this.refs.nhTable.exportExcel('采集字段管理');
    };

    //关闭内嵌页面
    handleFrameClose = () => {
        this.setCurrentPageShow('tableFlag');
        this.setState({
            formInitData: {},
            updatePkid: ''
        });
        this.refs.nhTable.filterTableData();
    };

    //新增字段提交
    addZdSubmitListener = () => {
        this.form.validateFields((err, formData) => {
            if (err) {
                return;
            }
            let controlType = JSON.parse(formData.kjcs);
            if( (formData.zdlx=="DATE" && controlType.type=="datepicker") || 
                (formData.zdlx=="DATE" && controlType.type=="monthpicker") || 
                (formData.zdlx=="DATE" && controlType.type=="timepicker") || 
                (formData.zdlx=="DATE" && controlType.type=="datetimepicker") || 
                (formData.zdlx=="VARCHAR" && controlType.type=="upload") ||
                (formData.zdlx=="VARCHAR" && controlType.type=="oldupload") ||
                (formData.zdlx=="VARCHAR2" && controlType.type=="textarea") ||
                (formData.zdlx=="VARCHAR2" && controlType.type=="input") ||
                (formData.zdlx=="NUMBER" && controlType.type=="inputnumber") ||
                (formData.zdlx=="VARCHAR2" && controlType.type=="radio") ||
                (formData.zdlx=="VARCHAR2" && controlType.type=="switch") ||
                (formData.zdlx=="VARCHAR2" && controlType.type=="nhcascader") ||
                (formData.zdlx=="VARCHAR2" && controlType.type=="multiselect") ||
                (formData.zdlx=="VARCHAR2" && controlType.type=="select")
             ){
            NHFetch(basicUrl + "insert", "POST", formData)
                .then(resData => {
                    if (resData.data) {
                        message.success("新增成功！");
                        this.setCurrentPageShow('tableFlag');
                        this.refs.nhTable.filterTableData();
                    } else {
                        message.error("新增失败！请确认是否存在该字段！");
                    }
                })
            }else{
                message.error("字段类型与控件类型不一致,请修改后保存!");
            }
        });
    };

    //修改按钮点击事件
    updateBtnClickListener = (record) => {
        if (record) {
            let pkid = record.PKID;
            this.setCurrentPageShow('updateFlag');
            this.setState({
                updatePkid: pkid,
                formInitData: {
                    pkid: record.PKID,
                    zdbz: record.ZDBZ,
                    zdmc: record.ZDMC,
                    zdlx: record.ZDLX,
                    zdcd: record.ZDCD,
                    zdsx: record.ZDSX,
                    zdms: record.ZDMS,
                    kjcs: record.KJCS,
                    xxdm: record.XXDM || "",
                    isUpdate: true
                }
            });
        }
    };

    //修改字段提交
    updateZdSubmitListener = () => {

        this.form.validateFields((err, formData) => {
            if (err) {
                return;
            }
            let controlType = JSON.parse(formData.kjcs);
            if( (formData.zdlx=="DATE" && controlType.type=="datepicker") || 
                (formData.zdlx=="DATE" && controlType.type=="monthpicker") || 
                (formData.zdlx=="DATE" && controlType.type=="timepicker") || 
                (formData.zdlx=="DATE" && controlType.type=="datetimepicker") || 
                (formData.zdlx=="VARCHAR" && controlType.type=="upload") ||
                (formData.zdlx=="VARCHAR" && controlType.type=="oldupload") ||
                (formData.zdlx=="VARCHAR2" && controlType.type=="textarea") ||
                (formData.zdlx=="VARCHAR2" && controlType.type=="input") ||
                (formData.zdlx=="NUMBER" && controlType.type=="inputnumber") ||
                (formData.zdlx=="VARCHAR2" && controlType.type=="radio") ||
                (formData.zdlx=="VARCHAR2" && controlType.type=="switch") ||
                (formData.zdlx=="VARCHAR2" && controlType.type=="nhcascader") ||
                (formData.zdlx=="VARCHAR2" && controlType.type=="multiselect") ||
                (formData.zdlx=="VARCHAR2" && controlType.type=="select")
             ){
                formData.pkid = this.state.updatePkid;
                NHFetch(basicUrl + "update", "POST", formData)
                    .then(resData => {
                        if (resData.data === 1) {
                            message.success("修改成功！");
                            this.setState({
                                formInitData: {},
                                updatePkid: ''
                            });
                            this.setCurrentPageShow('tableFlag');
                            this.refs.nhTable.filterTableData();
                        } else {
                            message.error("修改失败！");
                        }
                    })
            }else{
                message.error("字段类型与控件类型不一致,请修改后保存!");
            }
        });
    };

    //处理删除事件
    handleDeleteListener = (pkids) => {
        NHFetch(basicUrl + "deleteByMulti", "POST", pkids)
            .then(resData => {
                if (resData.data) {
                    message.success("删除操作成功！");
                    this.setState({showOperationBtn: false});
                    this.refs.nhTable.filterTableData();
                } else {
                    message.error("删除失败！");
                }
            });
    };

    //删除按钮点击事件
    deleteBtnClickListener = (record) => {
        //固定字段
        if (record.ZDSX === '1') {
            message.error("抱歉，固定字段无法删除！");
            return;
        }
        NHConfirm({
            content: "删除字段，会将该字段的值一并删除，此操作不可恢复！确定删除？", type: 'danger', onOk: () => {
                let pkid = record.PKID;
                this.handleDeleteListener([pkid]);
            }
        });
    };

    //批量删除
    batchDeleteListener = () => {
        //获取选择的行数据
        let nhTable = this.refs.nhTable;
        let selectedRowKeys = nhTable.state.selectedRowKeys;
        let selectedRows = nhTable.state.selectedRows;
        if (selectedRowKeys && selectedRowKeys.length > 0) {
            for (let i in selectedRows) {
                if (selectedRows[i].ZDSX === '1') {
                    message.error("抱歉，固定字段无法删除！");
                    return;
                }
            }
            NHConfirm({
                content: "删除该字段，会将字段的值一并删除，此操作不可恢复！确定删除？", type: "danger", onOk: () => {
                    this.handleDeleteListener(selectedRowKeys);
                }
            });
        } else {
            message.warning("请先选择需要删除的数据！");
        }
    };

    // table选择row后出现操作按钮
    rowSelectionChange = (selectedRowKeys) => {
        this.setState({
            showOperationBtn: !!selectedRowKeys.length
        });
    };

    render() {
        let isAddFlag = this.state.updatePkid === '';

        const columns = [
            {
                title: '序号',
                width: '60px',
                key: 'ROW_ID',
                dataIndex: 'ROW_ID',
                /* render: (text, record, index) => (
                    <div><span>{index + 1}</span></div>
                ) */
            }, {
                title: '字段标志',
                width: '120px',
                key: 'zdbz',
                dataIndex: 'ZDBZ',
                search: 'input',
                searchType:"input"
            }, {
                title: '字段名称',
                width: '120px',
                key: 'zdmc',
                dataIndex: 'ZDMC',
                sorted: false,
                search: 'input',
                searchType:"input"
            }, {
                title: '字段类型',
                width: '120px',
                key: 'zdlxmc',
                dataIndex: 'ZDLXMC',
                commonSearch: false,
                searchType:"select"
            }, {
                title: '字段长度',
                width: '120px',
                key: 'zdcd',
                dataIndex: 'ZDCD',
                searchType:"input"
            }, {
                title: '字段属性',
                width: '120px',
                key: 'zdsxmc',
                dataIndex: 'ZDSXMC',
                commonSearch: false,
                render: (text, record, index) => {
                    return record.ZDSX === '1' ? '固定字段' : '自定义字段';
                },
                searchType:"select"
            }, {
                title: '字段描述',
                width: '120px',
                key: 'zdms',
                dataIndex: 'ZDMS',
                search: 'input',
                sorted: false,
                searchType:"input"
            }, {
                title: '学校名称',
                width: '120px',
                key: 'xxmc',
                dataIndex: 'XXMC',
                search: 'input',
                sorted: false,
                searchType:"input"
            }
        ];

        //行内操作
        const action = [
            {title: '修改', onClick: this.updateBtnClickListener, auth: 'zhxg_yxxt_xxcj_zdgl:update'},
            {title: '删除', onClick: this.deleteBtnClickListener, auth: 'zhxg_yxxt_xxcj_zdgl:delete'}
        ];

        return (
            <div className={css.main_right_content} style={{height: getSize().windowH - 123}}>
                <div className={css.table} style={{display: this.state.frameVisibleMap.tableFlag ? 'block' : 'none'}}>
                    <NHTable ref='nhTable'
                             rowKey={record => record.PKID}
                             sign={"zhxg_yxxt_zdgl_queryPage"}
                             columns={columns}
                             rowSelectionChange={this.rowSelectionChange}
                             action={action}
                    >
                        {hasAuth("zhxg_yxxt_xxcj_zdgl:add") &&
                        <Button type="primary" onClick={this.addBtnClickListener}>新增</Button>}

                        {hasAuth("zhxg_yxxt_xxcj_zdgl:button_output") &&
                        <Button type="primary" ghost onClick={this.exportBtnClickListener}
                                style={{marginLeft: 10}}>导出</Button>}

                        {this.state.showOperationBtn && hasAuth("zhxg_yxxt_xxcj_zdgl:delete") &&
                        <Button type="danger" ghost style={{marginLeft: 10}}
                                onClick={this.batchDeleteListener}>删除</Button>}
                    </NHTable>
                </div>
                <NHContainerFrame title={isAddFlag ? '新增字段' : '修改字段'}
                                  visible={isAddFlag ? this.state.frameVisibleMap.addFlag : this.state.frameVisibleMap.updateFlag}
                                  contentWidth={24}
                                  onOk={isAddFlag ? this.addZdSubmitListener : this.updateZdSubmitListener}
                                  onCancel={this.handleFrameClose}
                >
                    <EditForm ref={(form) => {
                        this.form = form
                    }} initData={this.state.formInitData}/>
                </NHContainerFrame>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./components/xxcj/zdgl/index.js